module.exports = __webpack_public_path__ + "static/icon_bottom_2.69189e2d.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon_bottom_2.png
// module id = 1040
// module chunks = 2